import { createRouter, createWebHistory } from "vue-router";
import store from "@/store"; // Importe le store Vuex

// Pages
import Dashboard from "@/pages/Dashboard.vue";
import Employees from "@/pages/Employees/index.vue";
import CreateEmployees from "@/pages/Employees/Create.vue";
import ListEmployees from "@/pages/Employees/List.vue";
import EmployeProfile from "@/pages/Employees/Profile.vue";

import Trainings from "@/pages/Trainings/index.vue";
import ListTrainings from "@/pages/Trainings/List.vue";
import TraineeTimeline from "@/pages/Trainings/Timeline.vue";
import CreateTrainings from "@/pages/Trainings/Create.vue";
import PaymentTraining from "@/pages/Trainings/Payment.vue";
import TrainingSuccess from "@/pages/Trainings/Success.vue";

import Register from "@/pages/Register.vue";
import Login from "@/pages/Login.vue";
import ForgotPassword from "@/pages/ForgotPassword.vue";
import Settings from "@/pages/Settings.vue";

import SetupCompany from "@/pages/SetupCompany.vue";
import Invoices from "@/pages/Invoices.vue";
import Certificates from "@/pages/Certificates.vue";
import Conventions from "@/pages/Conventions.vue";
import Transactions from "@/pages/Transactions.vue";
import PurchaseCredits from "@/pages/PurchaseCredits.vue";
import Moderations from "@/pages/Moderations.vue";

import Catalog from "@/pages/Trainings/Catalog.vue";

const routes = [
  {
    path: "/",
    component: Dashboard,
    name: "dashboard",
    meta: { requiresAuth: true }
  },
  {
    path: "/register",
    component: Register,
    name: "register",
  },
  {
    path: "/login",
    component: Login,
    name: "login",
  },
  {
    path: "/catalog",
    component: Catalog,
    name: "catalog",
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
    name: "forgot-password",
  },
  {
    path: "/setup-company",
    component: SetupCompany,
    name: "setup-company",
    meta: { requiresAuth: true }
  },
  {
    path: "/settings",
    component: Settings,
    name: "settings",
    meta: { requiresAuth: true }
  },
  {
    path: "/invoices",
    component: Invoices,
    name: "invoices",
    meta: { requiresAuth: true }
  },
  {
    path: "/conventions",
    component: Conventions,
    name: "conventions",
    meta: { requiresAuth: true }
  },
  {
    path: "/certificates",
    component: Certificates,
    name: "certificates",
    meta: { requiresAuth: true }
  },
  {
    path: "/moderations",
    component: Moderations,
    name: "moderations",
    meta: { requiresAuth: true }
  },
  {
    path: "/transactions",
    component: Transactions,
    name: "transactions",
    meta: { requiresAuth: true }
  },
  {
    path: "/purchase-credits",
    component: PurchaseCredits,
    name: "purchase-credits",
    meta: { requiresAuth: true }
  },
  {
    path: "/employees",
    component: Employees,
    name: "employees",
    meta: { requiresAuth: true },
    children: [
      {
        path: "create", // Pas besoin du slash ici, car c'est une route enfant
        component: CreateEmployees,
        name: "create-employee",
        meta: { requiresAuth: true },
      },
      {
        path: "list", // Pas besoin du slash ici, car c'est une route enfant
        component: ListEmployees,
        name: "list-employee",
        meta: { requiresAuth: true },
      },
      {
        path: "profile/:employeeId", // Pas besoin du slash ici, car c'est une route enfant
        component: EmployeProfile,
        name: "profile-employee",
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/trainings",
    component: Trainings,
    name: "trainings",
    meta: { requiresAuth: true },
    children: [
      {
        path: "create", // Pas besoin du slash ici, car c'est une route enfant
        component: CreateTrainings,
        name: "create-trainings",
        meta: { requiresAuth: true },
      },
      {
        path: "list", // Pas besoin du slash ici, car c'est une route enfant
        component: ListTrainings,
        name: "list-trainings",
        meta: { requiresAuth: true },
      },
      {
        path: "timeline-trainee/:traineeId", // Pas besoin du slash ici, car c'est une route enfant
        component: TraineeTimeline,
        name: "timeline-trainee",
        meta: { requiresAuth: true },
      },
      {
        path: "payment", // Pas besoin du slash ici, car c'est une route enfant
        component: PaymentTraining,
        name: "payment",
        meta: { requiresAuth: true },
      },
       {
        path: "success", // Pas besoin du slash ici, car c'est une route enfant
        component: TrainingSuccess,
        name: "success",
        meta: { requiresAuth: true },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn; // Vérifie l'état dans le store Vuex

  // Vérifie si la route nécessite d'être connecté
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      // Redirige vers la page de login si non connecté
      return next({ name: "login" });
    }
  }

  // Si tout est OK, passe à la page suivante
  next();
});

export default router;
